import React from 'react'
import Input from '../input'
import Text from '../text'

export const InputInlineWithLabel = ({ inputClass, title, placeholder, value, setValue, editable = true, message }) => {
  return (
    <div>
      <Text bold color='#808B96' size='0.82'>
        {title.toUpperCase()}
      </Text>
      <Input
        className={inputClass}
        name={title}
        placeholder={placeholder}
        value={value}
        editable={editable}
        onChange={setValue}
      />
      <Text size='0.8' color='var(--red-text-color)'>
        {message}
      </Text>
    </div>
  )
}
